function Resume() {

return (
    <section className="resume-container flex-row">

        <h2 className="section-title">Tools & Technologies</h2>

        <section className="resume-section">

            <div className="skills-list">

                <div className="skill-category">
                    <h3>Front-End Development</h3>
                    <ul>
                        <li>HTML5</li>
                        <li>CSS3</li>
                        <li>JavaScript</li>
                        <li>React</li>
                        <li>Bootstrap</li>
                        <li>Responsive Web Design</li>
                    </ul>
                </div>

                <div className="skill-category">
                    <h3>Back-End Development</h3>
                    <ul>
                        <li>Node.js</li>
                        <li>Express.js</li>
                        <li>Java</li>
                        <li>REST APIs</li>
                        <li>GraphQL</li>
                    </ul>
                </div>

                <div className="skill-category">
                    <h3>Databases</h3>
                    <ul>
                        <li>MySQL</li>
                        <li>SQL Server</li>
                        <li>MongoDB</li>
                        <li>Mongoose</li>
                    </ul>
                </div>

                <div className="skill-category">
                    <h3>Development Tools</h3>
                    <ul>
                        <li>Git</li>
                        <li>GitHub</li>
                        <li>VS Code</li>
                        <li>npm</li>
                        <li>Insomnia</li>
                    </ul>
                </div>

                <div className="skill-category">
                    <h3>Technology & Digital Platforms</h3>
                    <ul>
                        <li>SaaS Platforms</li>
                        <li>Technology Operations</li>
                        <li>Application Lifecycle Management</li>
                        <li>Website Content Management</li>
                        <li>Digital Platforms</li>
                    </ul>
                </div>

                <div className="skill-category">
                    <h3>Accessibility & UX</h3>
                    <ul>
                        <li>WCAG 2.1</li>
                        <li>ADA Accessibility</li>
                        <li>UX/UI</li>
                        <li>Responsive Design</li>
                    </ul>
                </div>

            </div>

        </section>

    </section>
);

};

export default Resume;
